import { C } from '../../data/tokens.js';
import { ALL_SVCS } from '../../data/index.js';

export function PriceEditModal({
  editingPrice, setEditingPrice, editPriceValue, setEditPriceValue, profile, setProfile
}) {
  if (!editingPrice) return null;

  return (
    <div role="dialog" aria-modal="true" aria-labelledby="modal-title" style={{ position: "absolute", inset: 0, background: "rgba(28,28,40,0.5)", backdropFilter: "blur(8px)", zIndex: 999, display: "flex", alignItems: "center", justifyContent: "center", padding: 20 }}
      onClick={() => setEditingPrice(null)} onKeyDown={e => { if (e.key === "Escape") setEditingPrice(null); }}>
      <div onClick={e => e.stopPropagation()} style={{ background: C.bg1, border: `1px solid ${C.border}`, borderRadius: 18, padding: "24px 22px", width: "100%", maxWidth: 340, boxShadow: "0 24px 64px rgba(0,0,0,0.6)" }}>
        <div style={{ fontSize: 9, fontWeight: 700, letterSpacing: "2px", textTransform: "uppercase", color: C.ghost, marginBottom: 6 }}>Set your price</div>
        <div id="modal-title" style={{ fontFamily: "'Playfair Display',serif", fontSize: 22, fontWeight: 700, color: C.white, marginBottom: 16 }}>{editingPrice.label}</div>
        <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 12 }}>
          <span style={{ fontFamily: "'IBM Plex Mono',monospace", fontSize: 24, fontWeight: 700, color: C.gold }}>$</span>
          <input type="number" autoFocus value={editPriceValue}
            onChange={e => setEditPriceValue(e.target.value)}
            style={{ fontFamily: "'IBM Plex Mono',monospace", fontSize: 28, fontWeight: 700, color: C.gold, background: C.bg2, border: `1px solid ${C.borderHi}`, borderRadius: 10, padding: "10px 14px", width: "100%", outline: "none" }} />
        </div>
        <div style={{ fontSize: 11, color: C.muted, marginBottom: 16, lineHeight: 1.5 }}>
          This price will be saved to your price list and used on all future estimates for {editingPrice.label.toLowerCase()}.
        </div>
        <div style={{ display: "flex", gap: 8 }}>
          <button onClick={() => {
            const val = parseFloat(editPriceValue);
            if (!isNaN(val) && val >= 0) {
              setProfile(p => ({ ...p, customPrices: { ...p.customPrices, [editingPrice.id]: val } }));
            }
            setEditingPrice(null);
          }} style={{ flex: 1, padding: "14px 0", borderRadius: 12, background: C.gold, border: "none", color: C.bg0, fontSize: 14, fontWeight: 700, cursor: "pointer", fontFamily: "'DM Sans',sans-serif" }}>
            Save to price list
          </button>
          <button onClick={() => setEditingPrice(null)}
            style={{ padding: "14px 16px", borderRadius: 12, background: "none", border: `1px solid ${C.border}`, color: C.muted, fontSize: 14, cursor: "pointer", fontFamily: "'DM Sans',sans-serif" }}>
            Cancel
          </button>
        </div>
        {profile.customPrices?.[editingPrice.id] !== undefined && (
          <button onClick={() => {
            setProfile(p => {
              const cp = { ...p.customPrices };
              delete cp[editingPrice.id];
              return { ...p, customPrices: cp };
            });
            setEditingPrice(null);
          }} style={{ width: "100%", padding: "10px 0", marginTop: 8, borderRadius: 10, background: "none", border: "none", color: C.ghost, fontSize: 12, cursor: "pointer", fontFamily: "'DM Sans',sans-serif" }}>
            Reset to default (${ALL_SVCS.find(s => s.id === editingPrice.id)?.addon || 0})
          </button>
        )}
      </div>
    </div>
  );
}
